import React from "react"
import { Typography } from "@mui/material"
import { FlagsIconSeeker, IconSeeker } from "@ui-seeker/core"


export default function AppOfficesBlock({ name, country, type, distinctOffices, dropDown, typeDrop, countryDrop, ...props }) {

	const icon = {
		airport: 'plane-departure',
		downtown: 'city',
		truck: 'truck',
		train_station: 'train'
	}[type] || 'plane-departure'

	const iconDropOff = {
		airport: 'plane-arrival',
		downtown: 'mountain-city',
		truck: 'truck-arrow-right',
		train_station: 'train-track'
	}[typeDrop] || 'plane-arrival'

	return <Typography variant="subtitle2" {...props} sx={{ display: 'flex', alignItems: 'center', gap: .6, ...props?.sx }}>
		<FlagsIconSeeker countryName={country}/>
		<IconSeeker icon={icon}/>
		{name}
		{!!distinctOffices && <IconSeeker
			icon={iconDropOff}
			tooltip={`Distinct Drop off: ${dropDown}`}
			sx={{ color: "error.main" }}
		/>}
	</Typography>
}